import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="cms-booking-form"
export default class extends Controller {
  static targets =[
    'checkdate',
    'checkDateSubmit',
    'dateInput',
    'monthlyInputLabel',
    'yearlyInputLabel',
  ]

  checkdate(){
    this.checkdateTarget.value = 'true';
  }

  checkDateSubmit(){
    this.checkDateSubmitTarget.click();
  }

  update() {
    const dateParts = this.dateInputTarget.value.split('/');
    if (dateParts.length !== 3) {
      // Handle invalid input
      return;
    }

    const day = parseInt(dateParts[0], 10);
    const month = parseInt(dateParts[1], 10) - 1; // Months are 0-based in JavaScript
    const year = parseInt(dateParts[2], 10);

    var date = new Date(year, month, day);

    if (isNaN(date.getTime())) { date = null }
    this.updateMonthlyInputLabel(date)
    this.updateYearlyInputLabel(date)
  }

  updateMonthlyInputLabel(date) {
    if (!date) {
      this.monthlyInputLabelTarget.innerHTML = 'monthly'
      return
    }
    console.log(date)
    const [weekdayIndex, ordinalNumber] = this.weekdayAndOrdinal(date);
    console.log(weekdayIndex, ordinalNumber)
    const weekday = date.toLocaleString('default', { weekday: 'long' });
    this.monthlyInputLabelTarget.innerHTML = `Monthly on the ${ordinalNumber} ${weekday}`;
  }

  updateYearlyInputLabel(date) {
    if (!date) {
      this.yearlyInputLabelTarget.innerHTML = 'Annually'
      return
    }

    var month = date.toLocaleString('default', { month: 'long' })
    var day = date.getDate()
    this.yearlyInputLabelTarget.innerHTML = `Annually on ${month} ${day}`
  }

  ordinalInWords(ordinalNumber) {
    const suffixes = ['th', 'st', 'nd', 'rd'];
    const suffixIndex = ordinalNumber % 100;
    return ordinalNumber + (suffixes[(suffixIndex - 20) % 10] || suffixes[suffixIndex] || suffixes[0]);
  }

  weekdayAndOrdinal(date) {
    const weekdayIndex = date.getDay();
    let count = 0;
    for (let i = 1; i <= date.getDate(); i++) {
      const tempDate = new Date(date.getFullYear(), date.getMonth(), i);
      if (tempDate.getDay() === weekdayIndex) {
        count++;
      }
    }

    const ordinalNumber = this.ordinalInWords(count);
    return [weekdayIndex, ordinalNumber];
  }
}
